import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopPayrollSettingsModel } from '../../../system/shopinfo/model/shopinfo.model';
import { ShopPayrollSettingsService } from '../../shop-payroll-settings/shop-payroll-settings.service';
import { PayrollGroupService } from '../../payroll-group/payroll-group.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { Observable, forkJoin, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PermissionService } from 'src/app/auth/permission.service';
import { StaffPayrollGroupService } from '../staff-payroll-group.service';

@Component({
  selector: 'app-staff-payroll-group-edit',
  templateUrl: './staff-payroll-group-edit.component.html',
  styleUrls: ['./staff-payroll-group-edit.component.scss'],
  standalone: false
})
export class StaffPayrollGroupEditComponent {

   title: string = "New Shop Payroll Settings";
    editForm: FormGroup;
    shopPayrollSettingsInfo: ShopPayrollSettingsModel = {};
    isFormDirty: boolean = false;
    payrollGroups: any[] = [];
    selectedGroupName: string = '';
    filteredGroups!: Observable<any[]>;
    id: string | null = null;
    permission: any;
  shop_id: string | null;
  
    constructor(
      private router: Router,
      private builder: FormBuilder,
      private route: ActivatedRoute,
      private staffPayrollGroupService: StaffPayrollGroupService,
      private payrollGroupService: PayrollGroupService,
      private snackBarService: SnackBarService,
      private permissionService: PermissionService,
      public dialog: MatDialog
    ) {
      this.id = this.route.snapshot.paramMap.get('id');
      this.shop_id = this.route.snapshot.paramMap.get('shop_id');
      this.editForm = this.builder.group({
        code: this.builder.control('', ),
        name: this.builder.control('', ),
    
        group_code: this.builder.control('', ),
        payroll_code: this.builder.control('', [
          Validators.required,
          Validators.maxLength(7),
          Validators.minLength(7)
        ]),
        department_name: this.builder.control('', ),
        category_name: this.builder.control('', ),
        fixed_pay: this.builder.control(false), // Add fixed_pay as boolean
      });
  
      this.editForm.valueChanges.subscribe(() => {
        this.isFormDirty = true;
      });
  
      const requestData = {
        search: {
          filters: {
            column: [],
            scope: { limit: 100, offset: 0 },
          },
          sort: [{ column: "code", order: "asc" }],
        },
      };
  
      const groups$ = this.payrollGroupService.getList(requestData);
      // You may need to replace 'yourShopId' with the actual shop_id value from your context
      const shopId = this.shop_id ? parseInt(this.shop_id) : 0;
      const settings$ = this.id && parseInt(this.id) !== 0 ? this.staffPayrollGroupService.getById(parseInt(this.id), shopId) : of(null);
  
      forkJoin({ groups: groups$, settings: settings$ }).subscribe({
        next: ({ groups, settings }) => {
          if (groups.status === "SUCCESS") {
            this.payrollGroups = groups.data['payroll_groups'];
            this.filteredGroups = this.editForm.get('group_code')!.valueChanges.pipe(
              startWith(''),
              map((value: string) => this._filter(value || ''))
            );
          } else {
            let snackBarData: SnackBarData = {
              message: groups.message,
              title: "Failed!!!",
              type: "error",
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
  
          if (settings && settings.status === 'SUCCESS') {
            this.shopPayrollSettingsInfo = settings.data.payroll_group;
            // Patch fixed_pay as boolean
            const patchValue = {
              ...this.shopPayrollSettingsInfo,
              fixed_pay: this.shopPayrollSettingsInfo.fixed_pay === 'Yes'
            };
            this.editForm.patchValue(patchValue);
            const groupCode = this.shopPayrollSettingsInfo.group_code;
            const selectedGroup = this.payrollGroups.find((g: any) => g.code === groupCode);
            if (selectedGroup) {
              this.selectedGroupName = selectedGroup.name;
              if (!this.shopPayrollSettingsInfo.payroll_group_id) {
                this.shopPayrollSettingsInfo.payroll_group_id = selectedGroup.id;
                this.editForm.patchValue({ payroll_group_id: selectedGroup.id });
              }
            }
            this.title = this.getTitle();
            this.isFormDirty = false;
          } else if (this.id && parseInt(this.id) !== 0) {
            let snackBarData: SnackBarData = {
              message: settings ? settings.message : 'Failed to load settings!',
              title: 'Failed!!!',
              type: 'error'
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to get data from server. Connection to the server failed.',
            title: 'Failed!!!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
      this.permission = this.permissionService.getPagePermission('payroll_settings');
  
    }
  
    ngOnInit(): void { }
  
    /**
     * Dirtyness check
     * @returns
     */
    isDirty(): boolean {
      return this.isFormDirty;
    }
  
    /**
     * checks the form is edited
     */
    navBack(): void {
      this.router.navigate(['/payroll/staff-payroll-group']);
    }
  
    /**
     * @returns the title for the dialog
     * since the same dialog is used for edit and new, dynamically decide the title
     */
    getTitle(): string {
      if (this.shopPayrollSettingsInfo && (!this.shopPayrollSettingsInfo.shop_id || this.shopPayrollSettingsInfo.shop_id === 0)) {
        return "New Shop Payroll Settings";
      }
      return "Editing : " + this.shopPayrollSettingsInfo.name;
    }
  
    onGroupSelected(event: MatAutocompleteSelectedEvent): void {
      const code = event.option.value;
      const selectedGroup = this.payrollGroups.find((g: any) => g.code === code);
      if (selectedGroup) {
        this.editForm.patchValue({
          payroll_group_id: selectedGroup.id
        });
        this.selectedGroupName = selectedGroup.name;
      }
    }
  
    clearGroup(): void {
      this.editForm.get('group_code')?.setValue('');
      this.editForm.get('payroll_group_id')?.setValue(null);
      this.selectedGroupName = '';
    }
  
    private _filter(value: string): any[] {
      const filterValue = value.toLowerCase();
      return this.payrollGroups.filter((group: any) => group.code.toLowerCase().includes(filterValue));
    }
  
    /**
     * On save
     * if the details are valid call the api to update the changes.
     */
    save(): void {
        if (this.editForm.valid) {
        const formValue = this.editForm.value;
        const payload = {
          id: this.shopPayrollSettingsInfo.id,
          payroll_code: formValue.payroll_code,
          shop_id: this.shopPayrollSettingsInfo.shop_id,
          can_export: formValue.fixed_pay ? 1 : 0, 
        };
        this.staffPayrollGroupService.update(payload).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              this.isFormDirty = false;
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + this.shopPayrollSettingsInfo.name + " has been updated successfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              // this.router.navigate(['/payroll/shop-payroll-settings']);
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      
    }
    else {
      this.editForm.markAllAsTouched();
    } 
  }

}
